"use strict";

var _classCallCheck = require("/opt/build/repo/front/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/front/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Motion = void 0;

var MotionReduce_1 = require("./MotionReduce");

var Motion = /*#__PURE__*/function () {
  function Motion() {
    _classCallCheck(this, Motion);

    this.disable = false;
    this.reduce = new MotionReduce_1.MotionReduce();
  }

  _createClass(Motion, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.disable !== undefined) {
        this.disable = data.disable;
      }

      this.reduce.load(data.reduce);
    }
  }]);

  return Motion;
}();

exports.Motion = Motion;